import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../../contexts/DataContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiArrowLeft, FiShield, FiMail, FiSearch } = FiIcons;

const ExternalWhistleblowerHandling = () => {
  const navigate = useNavigate();
  const { reports = [], companies = [], loading } = useData();
  const [searchTerm, setSearchTerm] = useState('');

  const externalCases = (reports || []).filter(r => r?.externalHandling === true || r?.category === 'ekstern');

  const filteredCases = externalCases.map(report => {
    const company = (companies || []).find(c => c.id === (report.company_id || report.companyId));
    return {
      ...report,
      companyName: company?.name || 'Ukjent Bedrift',
      date_display: report.created_at || report.createdAt || new Date().toISOString()
    };
  }).filter(c => {
    const matchesSearch = 
      c.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.title || '').toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSearch;
  });

  if (loading) return <div className="p-8 text-center">Laster eksterne saker...</div>;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={() => navigate('/superadmin')} className="p-2 hover:bg-gray-100 rounded-lg">
            <SafeIcon icon={FiArrowLeft} />
          </button>
          <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <SafeIcon icon={FiShield} className="text-indigo-600" />
            Ekstern Varslingshåndtering
          </h1>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 py-8 flex-1 w-full">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-6">
            <div className="relative">
                <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                    type="text"
                    placeholder="Søk i bedrift eller tittel..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="bg-gray-50 border-b border-gray-100 uppercase text-xs font-bold text-gray-500">
                        <tr>
                            <th className="px-6 py-4">Bedrift</th>
                            <th className="px-6 py-4">Sakstittel</th>
                            <th className="px-6 py-4">Status</th>
                            <th className="px-6 py-4 text-right">Handling</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {filteredCases.length > 0 ? filteredCases.map(caseItem => (
                            <tr key={caseItem.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-6 py-4 font-bold text-gray-900">{caseItem.companyName}</td>
                                <td className="px-6 py-4">
                                    <div className="text-sm">{caseItem.title || 'Uten tittel'}</div>
                                    <div className="text-[10px] text-gray-400">{new Date(caseItem.date_display).toLocaleDateString()}</div>
                                </td>
                                <td className="px-6 py-4">
                                    <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase ${
                                        caseItem.status === 'resolved' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
                                    }`}>
                                        {caseItem.status === 'resolved' ? 'Løst' : 'Pågår'}
                                    </span>
                                </td>
                                <td className="px-6 py-4 text-right">
                                    <button className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors">
                                        <SafeIcon icon={FiMail} />
                                    </button>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="4" className="px-6 py-12 text-center text-gray-500 italic">Ingen eksterne saker funnet.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalWhistleblowerHandling;